/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 */

/**
 * The KNet Channels chat bubble for a signed-in contact on KnetDB's home (openspec
 * enterprise-client-billing in flexprice-front, client-crm-links, task 3.6). KnetDB answers
 * /api/knet/company-chat with the widget and the contact's identity (identifier + server-computed HMAC), or
 * {chat: null} for anyone who is not a contact; then the bubble opens conversations as that contact.
 */

import { fetchFromHome } from "app/common/urlUtils";

export interface ClientChat {
  base_url: string;
  website_token: string;
  identifier: string;
  identifier_hash: string;
  email: string | null;
}

let started = false;

/** Shows the bubble once per page load, only for contacts. Never throws. */
export async function maybeShowCompanyChat(): Promise<void> {
  if (started) { return; }
  started = true;
  try {
    const resp = await fetchFromHome("/api/knet/company-chat", { credentials: "include" });
    if (!resp.ok) { return; }
    const { chat } = await resp.json() as { chat: ClientChat | null };
    if (chat?.base_url && chat.website_token) { startChatwoot(chat); }
  }
  catch {
    // The bubble is optional; the home page works without it.
  }
}

function startChatwoot(chat: ClientChat) {
  const w = window as any;
  window.addEventListener("chatwoot:ready", () => {
    w.$chatwoot?.setUser(chat.identifier, {
      identifier_hash: chat.identifier_hash,
      ...(chat.email ? { email: chat.email } : {}),
    });
  }, { once: true });
  const script = document.createElement("script");
  script.src = `${chat.base_url.replace(/\/+$/, "")}/packs/js/sdk.js`;
  script.async = true;
  script.onload = () => w.chatwootSDK?.run({ websiteToken: chat.website_token, baseUrl: chat.base_url });
  document.head.appendChild(script);
}
